import { MarketsTableData } from 'api/selectors/pages';
import { compareRatings } from 'domain/utils';
import { compareEitherAmounts } from 'utils/amount';
import { isRight, toEither } from 'utils/either';

function isBadMarket(data: MarketsTableData): boolean {
  return isRight(data.rating) && data.rating.value.right > 1;
}

export function takeTopBadMarkets(value: MarketsTableData[]) {
  return value
    .filter(market => {
      const totalDeposit = toEither(market.totalDeposit.value);
      return isBadMarket(market) && isRight(totalDeposit) && totalDeposit.value.right.gt(0);
    })
    .sort((a, b) => {
      const ratingsCompareResult = compareRatings(b.rating, a.rating);

      if (!ratingsCompareResult) {
        return compareEitherAmounts(a.totalDeposit.value, b.totalDeposit.value);
      }

      return ratingsCompareResult;
    })
    .slice(0, 3);
}
